import type { Caching } from "@/lib/caching"
import { isCachingMetadata } from "@/lib/caching/isMetadata"
import { isRecord } from "@/lib/validation/isRecord"

export const isCachedPayload = (
  subject: unknown
): subject is Caching.Payload<unknown> => {
  if (isRecord(subject)) {
    if (!isCachingMetadata(subject.caching)) {
      return false
    }

    return Object.hasOwn(subject, `data`)
  }

  return false
}
